<template>
  <transition name="modal-scale" appear>
    <div v-if="open" class="fixed inset-0 z-[130] flex items-center justify-center">
      <div class="absolute inset-0 bg-slate-950/80 backdrop-blur" @click="emit('close')" />
      <div
        class="relative w-[380px] rounded-2xl bg-slate-950/90 border border-slate-700/60 shadow-lg p-6 space-y-4"
      >
        <h3 class="text-lg font-semibold text-white">Confirm</h3>
        <p class="text-sm text-slate-300">{{ message }}</p>
        <div class="flex justify-end gap-2">
          <button type="button" class="btn-secondary" @click="emit('close')">Cancel</button>
          <button type="button" class="btn-danger" :disabled="loading" @click="emit('confirm')">
            {{ loading ? 'Working…' : 'Delete' }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
const props = defineProps<{
  open: boolean
  message: string
  loading?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'confirm'): void
}>()
</script>
